import React, { useEffect, useState } from 'react';
import { Image } from '@src/stories/elements/Image/Image';

export const BackgroundImage = ({ settings }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // Use mobile image if available, otherwise fallback to desktop image
  const imageUrl = isMobile && settings.section.background_image_mobile
    ? settings.section.background_image_mobile
    : settings.section.background_image;

  if (!imageUrl) {
    return null; // Return nothing if no image is provided
  }

  // Determine position styles based on settings
  const getPositionStyles = () => {
    const baseStyles = {
      position: 'absolute' as const,
      zIndex: settings.section.z_index || -1,
      transform: `translate(${settings.section.image_offset_x || 0}%, ${settings.section.image_offset_y || 0}%)`,
    };

    const minHeight = isMobile
      ? `${settings.section.mobile_min_height || 250}px`
      : `${settings.section.desktop_min_height || 400}px`;

    const padding = isMobile
      ? `${settings.section.padding_top_mobile || 0}px ${settings.section.padding_left_right_mobile || 0}px ${settings.section.padding_bottom_mobile || 0}px`
      : `${settings.section.padding_top_desktop || 0}px ${settings.section.padding_left_right_desktop || 0}px ${settings.section.padding_bottom_desktop || 0}px`;

    // Get section height based on device
    const sectionHeight = isMobile 
      ? settings.section.section_height_mobile || settings.section.section_height || 0
      : settings.section.section_height || 0;
      
    // Image height logic - default to section height if image_height is 0
    const imageHeight = settings.section.image_height 
      ? `${settings.section.image_height}px` 
      : sectionHeight > 0 ? '100%' : 'auto';

    // Determine position based on image_position setting
    switch (settings.section.image_position) {
      case 'left':
        return {
          ...baseStyles,
          left: '0',
          top: '0',
          bottom: '0',
          width: `auto`,
          height: imageHeight,
          minHeight,
          padding,
        };

      case 'right':
        return {
          ...baseStyles,
          right: '0',
          top: '0',
          bottom: '0',
          width: `auto`,
          height: imageHeight,
          minHeight,
          padding,
        };

      case 'bottom':
        return {
          ...baseStyles,
          left: '0',
          right: '0',
          bottom: '0',
          height: imageHeight === 'auto' ? `${settings.section.image_width || 50}%` : imageHeight,
          width: '100%',
          minHeight,
          padding,
        };

      case 'full':
      default:
        return {
          ...baseStyles,
          left: '0',
          right: '0',
          top: '0',
          bottom: '0',
          width: '100%',
          height: '100%',
          minHeight,
          padding,
        };
    }
  };

  return (
    <div className="background-image-container w-screen h-full relative">
      <div 
        className="background-image-wrapper" 
        style={getPositionStyles()}
      >
        <Image 
          imageUrl={imageUrl}
          alt=""
          style={{
            objectFit: 'cover',
            width: '100%',
            height: '100%',
          }}
        />
      </div>
    </div>
  );
};

export default BackgroundImage;